"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metrics = void 0;
var common_1 = require("../../utils/common");
var domMetrics_1 = require("../../utils/domMetrics");
var CounterAggregatedIncrementMetric_1 = require("../CounterAggregatedIncrementMetric/CounterAggregatedIncrementMetric");
var GaugeRawSetMetric_1 = require("../GaugeRawSetMetric/GaugeRawSetMetric");
var GaugeRawSetMetricBatch_1 = require("../GaugeRawSetMetric/GaugeRawSetMetricBatch");
var HistogramAggregatedObserveMetric_1 = require("../HistogramAggregatedObserveMetric/HistogramAggregatedObserveMetric");
var Metrics = /** @class */ (function () {
    function Metrics() {
    }
    Metrics.createMetric = function (MetricClass, metricData) {
        if (!Metrics.config || !Metrics.host) {
            return null;
        }
        var _a = Metrics.config, productName = _a.productName, serviceName = _a.serviceName;
        var metric = new MetricClass(__assign(__assign({}, metricData), { productName: productName, serviceName: serviceName }), Metrics.host);
        return metric;
    };
    Metrics.init = function (_a) {
        var productName = _a.productName, serviceName = _a.serviceName, _b = _a.env, env = _b === void 0 ? 'prod' : _b, _c = _a.language, language = _c === void 0 ? 'ru' : _c;
        Metrics.config = {
            env: env,
            language: language,
            productName: productName,
            serviceName: serviceName,
        };
        Metrics.host = (0, common_1.getBackendServer)(env, language);
    };
    Metrics.getConfig = function () {
        return Metrics.config;
    };
    Metrics.sendHistogramAggregatedObserveMetric = function (metricData) {
        return __awaiter(this, void 0, void 0, function () {
            var metric, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        metric = Metrics.createMetric(HistogramAggregatedObserveMetric_1.HistogramAggregatedObserveMetric, metricData);
                        if (!metric) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, metric.send()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Metrics.sendCounterAggregatedIncrementMetric = function (metricData) {
        return __awaiter(this, void 0, void 0, function () {
            var metric, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        metric = Metrics.createMetric(CounterAggregatedIncrementMetric_1.CounterAggregatedIncrementMetric, metricData);
                        if (!metric) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, metric.send()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Metrics.sendGaugeRawMetric = function (metricData) {
        return __awaiter(this, void 0, void 0, function () {
            var metric, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        metric = Metrics.createMetric(GaugeRawSetMetric_1.GaugeRawSetMetric, metricData);
                        if (!metric) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, metric.send()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Metrics.sendGaugeRawMetricList = function (metricDataList) {
        return __awaiter(this, void 0, void 0, function () {
            var config, host, metricList, metricBatch, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = Metrics.config, host = Metrics.host;
                        if (!config || !host) {
                            return [2 /*return*/];
                        }
                        metricList = metricDataList.reduce(function (list, metricData) {
                            var metric = Metrics.createMetric(GaugeRawSetMetric_1.GaugeRawSetMetric, metricData);
                            return metric
                                ? __spreadArray(__spreadArray([], __read(list), false), [metric], false) : list;
                        }, []);
                        if (!metricList.length) {
                            return [2 /*return*/];
                        }
                        metricBatch = new GaugeRawSetMetricBatch_1.GaugeRawSetMetricBatch(metricList, host);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, metricBatch.send()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Metrics.sendBaseMetrics = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var domMetrics;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        domMetrics = (0, domMetrics_1.composeDomMetrics)(params);
                        if (!domMetrics) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Metrics.sendGaugeRawMetricList(domMetrics)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated Use Metrics.sendGaugeRawMetric
     */
    Metrics.sendMetric = function (metricData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Metrics.sendGaugeRawMetric(metricData)];
            });
        });
    };
    /**
     * @deprecated Use Metrics.sendGaugeRawMetricList
     */
    Metrics.sendMetricList = function (metricDataList) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendGaugeRawMetricList(metricDataList)];
            });
        });
    };
    Metrics.config = null;
    Metrics.host = null;
    return Metrics;
}());
exports.Metrics = Metrics;
//# sourceMappingURL=Metrics.js.map